function _(str) {
    return str;
}

const units = [
    {
        unece: '@PL',
        name: _('Person'),
        namePlural: _('Personen'),
    },
    {
        unece: 'AA',
        name: _('Ball'),
        namePlural: _('Bälle'),
    },
    {
        unece: 'ANN',
        name: _('Jahr'),
        namePlural: _('Jahre'),
    },
    {
        unece: 'BA',
        name: _('Fass'),
        namePlural: _('Fässer'),
    },
    {
        unece: 'BC',
        name: _('Kiste'),
        namePlural: _('Kisten'),
    },
    {
        unece: 'BG',
        name: _('Beutel'),
        namePlural: _('Beutel'),
    },
    {
        unece: 'BJ',
        name: _('Eimer'),
        namePlural: _('Eimer'),
    },
    {
        unece: 'BO',
        name: _('Flasche'),
        namePlural: _('Flaschen'),
    },
    {
        unece: 'BR',
        name: _('Bar'),
        namePlural: _('Bar'),
    },
    {
        unece: 'BX',
        name: _('Kasten'),
        namePlural: _('Kästen'),
    },
    {
        unece: 'C62',
        name: _('Stück'),
        namePlural: _('Stück'),
    },
    {
        unece: 'CA',
        name: _('Dose'),
        namePlural: _('Dosen'),
    },
    {
        unece: 'CG',
        name: _('Käfig'),
        namePlural: _('Käfige'),
    },
    {
        unece: 'CI',
        name: _('Kanister'),
        namePlural: _('Kanister'),
    },
    {
        unece: 'CMT',
        name: _('Zentimeter'),
        namePlural: _('Zentimeter'),
    },
    {
        unece: 'CS',
        name: _('Behälter'),
        namePlural: _('Behälter'),
    },
    {
        unece: 'CT',
        name: _('Karton'),
        namePlural: _('Kartons'),
    },
    {
        unece: 'DAY',
        name: _('Tag'),
        namePlural: _('Tage'),
    },
    {
        unece: 'DZN',
        name: _('Dutzend'),
        namePlural: _('Dutzend'),
    },
    {
        unece: 'EA',
        name: _('Einheit'),
        namePlural: _('Einheiten'),
    },
    {
        unece: 'GRM',
        name: _('Gramm'),
        namePlural: _('Gramm'),
    },
    {
        unece: 'HUR',
        name: _('Stunde'),
        namePlural: _('Stunden'),
    },
    {
        unece: 'KGM',
        name: _('Kilogramm'),
        namePlural: _('Kilogramm'),
    },
    {
        unece: 'LTR',
        name: _('Liter'),
        namePlural: _('Liter'),
    },
    {
        unece: 'MLT',
        name: _('Milliliter'),
        namePlural: _('Milliliter'),
    },
    {
        unece: 'MON',
        name: _('Monat'),
        namePlural: _('Monate'),
    },
    {
        unece: 'MTK',
        name: _('Quadratmeter'),
        namePlural: _('Quadratmeter'),
    },
    {
        unece: 'MTQ',
        name: _('Kubikmeter'),
        namePlural: _('Kubikmeter'),
    },
    {
        unece: 'MTR',
        name: _('Meter'),
        namePlural: _('Meter'),
    },
    {
        unece: 'NE',
        name: _('Ausgepackt oder unverpackt'),
        namePlural: _('Ausgepackt oder unverpackt'),
    },
    {
        unece: 'PA',
        name: _('Paket'),
        namePlural: _('Pakete'),
    },
    {
        unece: 'PD',
        name: _('Ballen'),
        namePlural: _('Ballen'),
    },
    {
        unece: 'PE',
        name: _('Europalette'),
        namePlural: _('Europalette'),
    },
    {
        unece: 'PG',
        name: _('Platte'),
        namePlural: _('Platten'),
    },
    {
        unece: 'PK',
        name: _('Paket'),
        namePlural: _('Pakete'),
    },
    {
        unece: 'PR',
        name: _('Paar'),
        namePlural: _('Paare'),
    },
    {
        unece: 'QR',
        name: _('Lage'),
        namePlural: _('Lagen'),
    },
    {
        unece: 'RO',
        name: _('Rolle'),
        namePlural: _('Rollen'),
    },
    {
        unece: 'SA',
        name: _('Sack'),
        namePlural: _('Säcke'),
    },
    {
        unece: 'ST',
        name: _('Blatt'),
        namePlural: _('Blätter'),
    },
    {
        unece: 'SZ',
        name: _('Blatt'),
        namePlural: _('Blätter'),
    },
    {
        unece: 'TN',
        name: _('Dose'),
        namePlural: _('Dosen'),
    },
    {
        unece: 'TNE',
        name: _('Tonne (metrische Tonne)'),
        namePlural: _('Tonnen (metrische Tonne)'),
    },
];

module.exports = units;